import { NgModule } from '@angular/core';

import { SliderComponent } from './slider.component';

@NgModule({
    imports: [SliderComponent],
    exports: [SliderComponent]
})
export class SliderModule {}
